import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import sortBy from 'lodash/sortBy';

import { MONTHS } from '../../constants/cron.constants';

const MonthSelectionButton = ({
  value,
  onClick,
  isSelected = false,
}) => (
  <button
    type="button"
    className={classNames(
      'h-12',
      { 'bg-brand text-white': isSelected },
      { 'text-brand': !isSelected },
    )}
    onClick={() => onClick(value)}
  >
    {value}
  </button>
)

const MonthSelectionGrid = ({
  values = [],
  onValuesSelected = () => {},
}) => {
  const [selectedValues, setSelectedValues] = useState(values);

  const handleMonthButtonClick = (value) => {
    if (selectedValues.includes(value)) {
      const newSelectedValues = selectedValues.filter(curr => curr !== value);

      setSelectedValues(newSelectedValues)
      onValuesSelected(newSelectedValues)
    } else {
      const newSelectedValues = sortBy([...selectedValues, value]);

      setSelectedValues(newSelectedValues)
      onValuesSelected(newSelectedValues)
    }
  }

  useEffect(() => {
    onValuesSelected(selectedValues);
  }, [onValuesSelected, selectedValues])

  return (
    <div className="grid grid-cols-4 m-1">
      {
        MONTHS.map(monthVal => (
          <MonthSelectionButton
            key={`month-selection-${monthVal}`}
            value={monthVal}
            onClick={handleMonthButtonClick}
            isSelected={selectedValues.includes(monthVal)}
          />
        ))
      }
    </div>
  )
}

export default MonthSelectionGrid;
